<template>
  <div id="subevent-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="createLoading == 'created'" key="create-loading" />
        <el-row v-else key="content">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.content") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.contentMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="form.details" />
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.registrationTag") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.registrationTagMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="form.tagId">
                  <el-option v-for="item in tagList" :key="'mobile-tag-list-' + item.id" :value="item.id" :label="item.title">
                    <template>
                      <i class="fas fa-circle mr-2" :style="{ color: item.color }"></i>
                      <span>{{ item.title }}</span>
                    </template>
                  </el-option>
                </el-select>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="header">
                  <div class="title" @click="form.enableMobileRegistrations = !form.enableMobileRegistrations">
                    {{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.mobileRegisters") }}
                    <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.mobileRegistersMsg") }}</span>
                  </div>
                  <div class="actions">
                    <el-switch round icon="fas fa-plus" type="primary" size="small" v-model="form.enableMobileRegistrations"></el-switch>
                  </div>
                </div>

                <transition name="el-zoom-in-top">
                  <div class="w-100" v-show="form.enableMobileRegistrations">
                    <el-row :gutter="10" v-if="form">
                      <el-col :span="24" class="mt-3">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.tagRestriction") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.tagRestrictionMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-select v-model="form.registrationType" v-if="getEnums.find(x => x.title == 'SubEventRegistrationType').enums" clearable fi plterable @clear="form.registrationType = 0">
                            <el-option v-for="(item, index) in getEnums.find(x => x.title == 'SubEventRegistrationType').enums" :key="'organization-type-' + index" :value="item.key" :label="item.displayName"></el-option>
                          </el-select>
                        </div>
                      </el-col>

                      <el-col :span="24" class="mt-3" v-if="form.registrationType == 1">
                        <div class="custom-groups-list">
                          <div class="custom-groups-list-item" v-for="item in tagGroup" :key="item.id + '-tag-group-id'">
                            <div class="custom-groups-list-item-head" @click="item.show = !item.show">
                              <div class="custom-groups-list-item-head-title">
                                <span>
                                  <i class="fas fa-square mr-2" :style="'color:' + item.color"></i>
                                  {{ item.title }}
                                </span>
                                <span class="counter-badge" v-if="item.tags.filter(x => form.tagIds.some(y => y == x.id)).length > 0 ? true : false">{{ item.tags.filter(x => form.tagIds.some(y => y == x.id)).length }}</span>

                                <i class="fas fa-chevron-down" :class="{ active: item.show }"></i>
                              </div>
                              <el-button size="mini" type="primary" icon="fas fa-check" round @click.stop="selectAll(item.tags)">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.selectAll") }}</el-button>
                            </div>
                            <transition name="el-zoom-in-top" mode="out-in">
                              <div class="custom-groups-list-item-tags" v-if="item.show">
                                <div class="customg-group-tag-item" v-for="tagItem in item.tags" :key="tagItem.id" @click="toggleTag(tagItem.id)" :class="{ active: form.tagIds.some(x => x == tagItem.id) }">
                                  <div class="customg-group-tag-item-title">
                                    <div class="tag-color-circle" :style="{ backgroundColor: tagItem.color }"></div>
                                    <span>
                                      {{ tagItem.title }}
                                    </span>
                                  </div>

                                  <i class="fas fa-check"></i>
                                </div>
                              </div>
                            </transition>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form && form.enableMobileRegistrations">
            <el-col :span="24">
              <div class="w-100">
                <div class="custom-section-container">
                  <div class="section-header" @click="enableQuestions = !enableQuestions">
                    <div class="section-title">
                      <div class="section-head">
                        <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.registrationQuestions") }}</label>
                      </div>
                      <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.registrationQuestionsMsg") }}</span>
                    </div>
                    <div class="section-accordion">
                      <i class="fa" :class="enableQuestions ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </div>
                  </div>
                  <transition name="el-zoom-in-top">
                    <div class="section-wrapper" v-show="enableQuestions">
                      <QuestionLibrary :id="form.id" v-if="enableQuestions" :type="5" />
                    </div>
                  </transition>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="false ? 'sactive' : 'swaiting'">
                      <div class="custom-set-inner">
                        <i class="fas fa-qrcode"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.controlCenter") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.controlCenterMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-button round type="primary" size="mini" @click="$router.push({ path: 'venues' })">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.goControlCenter") }}</el-button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="createLoading != 'created'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'save'" :disabled="loading == 'save'" @click="save">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionLibrary from "../components/register-form/QuestionLibrary.vue";
import axios from "axios";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
export default {
  components: { quillEditor, QuestionLibrary },
  name: "SubEventAddUpdate",
  props: ["id"],
  mounted() {
    this.$store.dispatch("getVenues");
  },
  data() {
    return {
      settingsDock: false,
      enableQuestions: false,
      createLoading: false,
      activeKey: null,
      loading: false,
      form: null,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], ["clean"], ["link", "image"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      moment,
      timeout: null,
      tagGroup: []
    };
  },
  methods: {
    selectAll(tags) {
      tags.forEach(x => {
        var fIndex = this.form.tagIds.findIndex(y => y == x.id);
        if (fIndex == -1) {
          this.form.tagIds.push(x.id);
        }
      });
    },
    toggleTag(id) {
      var fIndex = this.form.tagIds.findIndex(x => x == id);
      if (fIndex != -1) {
        this.form.tagIds.splice(fIndex, 1);
      } else {
        this.form.tagIds.push(id);
      }
    },
    goControlPoint() {
      this.$router.push({ name: "venues" }).catch(() => {});
    },
    packetListChange(id) {
      if (this.form.registrationControlItems.some(x => x.id == id)) {
        var cindex = this.form.registrationControlItems.findIndex(x => x.id == id);
        this.form.registrationControlItems.splice(cindex, 1);
      } else {
        this.form.registrationControlItems.push({ id: id });
      }
    },
    changeType(type) {
      this.form.controlType = type;
      this.form.registrationControlItems = [];
    },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    async itemAddedVenue(item) {
      await this.$store.dispatch("getVenues");
      this.form.venueID = item.id;
    },
    deleteItem() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "delete";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteSubEvent", this.form.id);
        this.loading = false;
        if (!res.data.alert.hasError) {
          this.$emit("closeDialog");
        }
      }, 500);
    },
    save() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "save";
      this.validationErrors = [];
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateSubEvent", this.form);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getEventProgram");
        }
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },
    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },

    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    },
    async getSubEvent() {
      if (this.id != undefined && this.id != null) {
        this.createLoading = "created";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getSubEvent", this.id);
          var resGroup = await this.$store.dispatch("getGroups");
          this.tagGroup = resGroup.data.data.items.map(x => {
            x = {
              ...x,
              show: false
            };
            return x;
          });
          this.form = res.data.data.item;
          this.createLoading = false;
        }, 500);
      }
    }
  },

  mounted() {},
  computed: {
    tagList() {
      return this.$store.getters.getTagsList;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    }
  },
  async created() {
    await this.getSubEvent();
  }
};
</script>
<style lang="less" scoped>
#subevent-add-update-dialog {
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;

    .title {
      font-size: 16px;
      color: #292f3b;
      font-weight: 600;
      margin: 0;
      padding: 0;
      cursor: pointer;

      span {
        font-size: 13px;
        display: block;
        font-weight: 400;
        color: #505763;
        line-height: 1.3;
      }
    }

    .actions {
      display: block;

      .el-button-group {
        width: max-content;
      }
    }

    .packet-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;

      .packet-title-base {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
    }

    span {
      font-weight: 400;
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.control-point-info {
  padding: 1rem 2rem;
  .container-info {
    background-color: #eaeaea;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    border-radius: 8px;
    .qr-img {
      i {
        font-size: 40px;
      }
    }
    .title {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .el-button {
        width: 150px;
        font-weight: 600;
      }
    }
  }
}
.add-manager-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .add-manager-title {
    padding: 1rem;
    background-color: #f3f3f3;
    flex-direction: row;
    display: flex;
    gap: 1rem;
    align-items: center;
    .add-m-title {
      font-weight: bold;
    }
    .add-m-title,
    .add-m-btn {
      flex-shrink: 0;
    }
    .add-m-input {
      width: 100%;
    }
  }
}
.area-maps-title {
  display: grid;
  grid-template-columns: 1fr 8fr 6fr 2fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.subevent-add-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 8fr 6fr 2fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}
.cover-image {
  height: 250px;
}

.link-area-title {
  display: grid;
  grid-template-columns: 1fr 4fr 6fr 1fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.link-area-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 4fr 6fr 1fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}

.gallery-area-title {
  display: grid;
  grid-template-columns: 1fr 9fr 1fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.gallery-area-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: flex;
        gap: 0.5rem;
        align-items: center;
        & > img {
          border-radius: 8px;
        }
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
          & > span {
            color: rgb(159, 217, 231);
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 9fr 1fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.model-base-mid {
  min-width: 1140px;
}
.model-base-small {
  min-width: 550px;
}
.model-base-mini {
  min-width: 400px;
}
.switch-btn-container {
  display: flex;
  .el-button {
    flex-grow: 1;
  }
}
.register-form-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-block: 1rem;
  .content-title {
    background-color: #eaeaea;
    padding: 0.5rem 1rem;
    font-weight: bold;
    border-radius: 8px;
  }
  .packet-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 0.5rem 1rem;
    .packet-title {
      text-decoration: underline;
      color: #03658c;
      font-weight: bold;
    }
  }
}
.custom-groups-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .custom-groups-list-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .custom-groups-list-item-head {
      font-weight: bold;
      border-radius: 8px;
      padding: 10px;
      cursor: pointer;
      background-color: #f1f1f1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .custom-groups-list-item-head-title {
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        margin: unset !important;
        display: flex;
        gap: 10px;
        align-items: center;
        .counter-badge {
          padding: 5px 10px;
          width: max-content;
          border-radius: 8px;
          background-color: rgba(255, 255, 255, 0.8);
          font-weight: 600;
          color: #505763;
          font-size: 13px;
        }
        i {
          cursor: pointer;
          transition: all 0.3s;
          font-size: 13px;
          color: #505763;
          &.active {
            transform: rotate(-180deg);
          }
        }
      }
    }
    .custom-groups-list-item-tags {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 0.5rem;
      .customg-group-tag-item {
        border: 1px solid #f1f1f1;
        background-color: white;
        padding: 8px;
        border-radius: 8px;
        cursor: pointer;
        &.active {
          transition: all 0.3s ease-in-out;
          color: white;
          background-color: #03658c !important;
          i {
            display: block;
            color: white;
          }
          .customg-group-tag-item-title {
            span {
              color: white;
            }
          }
        }
        i {
          display: none;
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
        .customg-group-tag-item-title {
          display: flex;
          flex-direction: row;
          gap: 5px;
          align-items: center;
          span {
            font-weight: 500;
            color: #292f3b;
            font-size: 13px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 145px;
          }
          .tag-color-circle {
            border-radius: 50%;
            height: 10px;
            width: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubEventAddUpdate.vue